export default "__VITE_ASSET__fb70fcb8__"